<template>
    <div v-if="badges && badges.length > 0" class="c-startpage-hero-element-badges badge-group">
        <div v-for="badge in badges" :key="badge" class="badge-entry">
            {{ badge }}
        </div>
    </div>
</template>
<script setup lang="ts">
defineProps<{
  badges: string[];
}>();
</script>
<style lang="postcss" scoped>
  .badge-group {
    @apply flex gap-2 text-xs text-primary flex-wrap max-h-8 overflow-hidden mb-3 md:mb-0;
  }
  .badge-entry {
    @apply bg-primary-contrast border-primary border rounded-full px-3 py-1 text-nowrap;
  }
</style>
